import { buildQueryString, get, request } from '@fogia/core-web/libs/GrebbCommerceAPI/util';
import { API_URL } from '@fogia/core-web/constants';

const isFetchResponse = (value) =>
    value != null && typeof value === 'object' && typeof value.json === 'function' && typeof value.status === 'number';

const toSlugResult = async (response) => {
    const status = response.status();
    let data = null;
    try {
        const contentType = response.header?.('content-type') || '';
        if (typeof contentType === 'string' && contentType.includes('application/json')) {
            data = await response.response().json();
        } else {
            data = await response.body();
        }
        // AuthClient returns the Fetch Response when content-type is not exactly "application/json".
        if (isFetchResponse(data)) {
            try {
                data = await data.json();
            } catch (e) {
                data = null;
            }
        }
    } catch (e) {
        // Keep HTTP status even if the body isn't JSON (QA currently 500s HTML for missing slugs).
    }
    return { status, data };
};

export default async (applicationId, path, parameters = {}, url) => {
    // Build parameters.
    const builtParameters = buildQueryString(parameters);
    let slug = path;
    if (slug.length > 1 && slug.endsWith('/')) {
        slug = slug.slice(0, -1).toLowerCase();
    }

    const requestUrl = `/frontend/content/resolve-slug?application_id=${applicationId}&slug=${encodeURIComponent(
        slug,
    )}${builtParameters && `&${builtParameters}`}`;

    let response;
    if (!API_URL && url) {
        response = await request({ method: 'GET', path: requestUrl, baseUrl: url });
        if (response) {
            return toSlugResult(response);
        }
    }

    response = await get(requestUrl);

    return toSlugResult(response);
};
